import React from 'react';
import { getRegion, getEnv } from 'src/utils/Environment';
import { REGION } from 'src/core/config/APIConstants';
import './CoraProgressBanner.css';

const CoraProgressBanner: React.FC = () => {
    const region = getRegion(window.location.host, getEnv(window.location.host));
    
    const getSourceOfTruthLink = (): string => {
        switch (region) {
            case REGION.NRT:
                return 'https://outboundflow-nrt.amazon.com/FC/cora?durationOfRiskWindowInDays=7';
            case REGION.EU:
                return 'https://outboundflow-dub.amazon.com/FC/cora?durationOfRiskWindowInDays=7';
            case REGION.NA:
            default:
                return 'https://outboundflow-iad.amazon.com/FC/cora?durationOfRiskWindowInDays=7';
        }
    };

    return (
        <div className="cora-progress-banner">
            <div className="banner-content">
                This page is in-progress. Do NOT use this as a source of truth. For source of truth please navigate to{' '}
                <a href={getSourceOfTruthLink()} target="_blank" rel="noopener noreferrer">
                    this link
                </a>
            </div>
        </div>
    );
};

export default CoraProgressBanner;
